<script lang="ts">
	import imgDevRoom from "@assets/images/about/dev-room.jpg?webp&h=602&imagetools";
	import imgStudent from "@assets/images/about/student-dev.jpg?webp&w=843&imagetools";
	import imgTesting from "@assets/images/about/testing.jpg?webp&w=843&imagetools";
	import imgCompanyLunch from "@assets/images/career/company-lunch.jpg?webp&w=843&imagetools";
	import imgDavidOnCall from "@assets/images/career/david-on-call.jpg?webp&h=602&imagetools";
	import imgMountains from "@assets/images/career/mountains.jpg?webp&h=602&imagetools";
	import imgNelaRichardCoop from "@assets/images/career/nela-richard-coop.jpg?webp&h=602&imagetools";
	import imgPaintBallCrew from "@assets/images/career/paintball-crew-2023.jpg?webp&h=602&imagetools";
	import imgPubFootball from "@assets/images/career/pub-football.jpg?webp&h=602&imagetools";
	import imgSpeakerJacob from "@assets/images/career/speaker-jacob.jpg?webp&h=602&imagetools";
	import imgTomasRichardFocusing from "@assets/images/career/tomas-richard-focusing.jpg?webp&h=602&imagetools";
	import imgTyson007 from "@assets/images/career/tyson-007.jpg?webp&h=602&imagetools";
	import { Background } from "@components/Background.js";
	import BookInterview from "@components/BookInterview.svelte";
	import CareerPositionsCards from "@components/CareerPositionsCards.svelte";
	import Photogallery from "@components/Photogallery.svelte";
	import Pill from "@components/Pill.svelte";
	import { PillColor, PillSize } from "@components/PillProps.js";
	import Section from "@components/Section.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Link from "@components/common/Link.svelte";
	import type { MediaSrc } from "@components/common/MediaSrc.js";
	import { ButtonVariant } from "@components/common/getButtonClass.js";
	import Layout from "@components/layout/Layout.svelte";
	import arrowNext from "@core/assets/icons/arrow-next.svg?raw";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import type { CareerProps } from "./CareerProps.js";

	const { positions }: CareerProps = $props();
	const { tenant } = getGlobalTemplateProps();

	const commonHobbies = [
		"Deskové hry",
		"Paintball",
		"Counter Strike",
		"League of Legends",
		"Jízda na motokárách",
		"Střelba na střelnici",
	];

	const images: MediaSrc[] = [
		{
			src: imgDevRoom,
			type: "image/webp",
		},
		{
			src: imgDavidOnCall,
			type: "image/webp",
		},
		{
			src: imgTomasRichardFocusing,
			type: "image/webp",
		},
		{
			src: imgTesting,
			type: "image/webp",
		},
		{
			src: imgMountains,
			type: "image/webp",
		},
		{
			src: imgPaintBallCrew,
			type: "image/webp",
		},
		{
			src: imgPubFootball,
			type: "image/webp",
		},

		{
			src: imgCompanyLunch,
			type: "image/webp",
		},
		{
			src: imgSpeakerJacob,
			type: "image/webp",
		},
		{
			src: imgTyson007,
			type: "image/webp",
		},
		{
			src: imgStudent,
			type: "image/webp",
		},
		{
			src: imgNelaRichardCoop,
			type: "image/webp",
		},
	];
	const anchorOpenPositions = "otevrene-pozice";
</script>

<Layout>
	<Section background={Background.LightGradient} centered gridHeadline="container-6" gridDesc="container-6" hero>
		{#snippet headline()}
			<Formatted text="Přidej se do týmu, kde jsou cg[[výsledky důležitější]] než čas strávený v kanceláři" />
		{/snippet}
		{#snippet desc()}
			<p>
				<Formatted
					text="Nebaví tě být jen číslo ve zkostnatělém korporátu? sp[[Chceš, aby tvá práce měla smysl a přímý dopad na výsledky firmy?]] Přidej se do týmu Fastest. Hledáme nové posily (nejen) na IT pozice."
				/>
			</p>
		{/snippet}
		{#snippet cta()}
			<Link
				variant={ButtonVariant.PhloxOutlineLightBg}
				class="flex items-center justify-center mx-auto mt-2"
				href="#{anchorOpenPositions}"
			>
				<Formatted text="Zobrazit otevřené pozice" />
				<Icon icon={arrowNext} class="ml-2.5 text-fstgrey-900 w-5"></Icon>
			</Link>
		{/snippet}
	</Section>

	<Section
		gridHeadline="container-12 md:container-8 xl:container-start-2 xl:container-end-5"
		gridDesc="container-12 md:container-8 xl:container-start-7 xl:container-end-10"
		paddingFollowNext
	>
		{#snippet headline()}
			<Formatted text="Zakládáme si na férovosti a výsledcích a táhneme za cg[[jeden provaz]]" />
		{/snippet}
		{#snippet desc()}
			<p>
				<Formatted
					text="sp[[Korporátní manýry? Na to si ve Fastest nepotrpíme.]] Jsme parta 18 přátelských vývojářů, testerů, externích posil a dalších specialistů, kteří se specializují na vývoj webových či mobilních aplikací na cloudu, ale i na digitalizaci procesů ve firmách. "
				/>
			</p>
			<p>
				<Formatted
					text="Neřešíme, kdo stráví kolik času za počítačem v kanceláři, sp[[protože si myslíme, že nejdůležitější je výsledek a kvalita odvedené práce.]] Proto razíme volnou pracovní dobu a řada z nás běžně pracuje na dálku. Když se k nám přidáš, budeš součástí nadšenců do IT, kteří táhnou za jeden provaz a rádi posouvají hranice
				možného. Zakládáme si také na férovém přístupu – sp[[díky tomu jsme nejen kolegové, ale často i kamarádi.]]"
				/>
			</p>
		{/snippet}
	</Section>

	<Section
		gridHeadline="container-12 md:container-8 xl:container-start-2 xl:container-end-5"
		gridDesc="container-12 md:container-8 xl:container-start-7 xl:container-end-10"
		paddingFollowNext
	>
		{#snippet headline()}
			<Formatted text="cg[[Rádi společně]] paříme hry i hrajeme deskovky" />
		{/snippet}
		{#snippet desc()}
			<p>
				<Formatted
					text="Práce musí být i zábava a občas je potřeba si vyčistit hlavu, takže pravidelně pořádáme společné oddechové aktivity. Co nás mimo jiné baví?"
				/>
			</p>
			<ul class="flex gap-1 sm:gap-2 flex-wrap">
				{#each commonHobbies as label (label)}
					<Pill size={PillSize.Small} color={PillColor.White}>{label}</Pill>
				{/each}
			</ul>
		{/snippet}
	</Section>

	<Photogallery class="full-width mb-8" {images} />

	<Section
		id={anchorOpenPositions}
		gridHeadline="container-12 md:container-8 xl:container-start-2 xl:container-end-5"
		gridDesc="container-12 md:container-8 xl:container-start-7 xl:container-end-10"
		paddingFollowNext
	>
		{#snippet headline()}
			<Formatted text="cg[[Koho]] aktuálně hledáme?" />
		{/snippet}
		{#snippet desc()}
			<p>
				<Formatted
					text="sp[[Prohlédni si seznam otevřených pozic ve Fastest.]] Když ti žádná nesedne, nevadí – pokud myslíš, že bychom si mohli padnout do oka a navázat spolupráci, klidně se ozvi."
				/>
			</p>
			<p>
				<Formatted
					text="Nečekej otravné pohovory na několik kol. Raději si s tebou dáme pohodový call, kde se navzájem poznáme, nebo jen tak posedíme u kafe."
				/>
			</p>
		{/snippet}

		<CareerPositionsCards class="pt-8 lg:pt-20" {tenant} {positions} />
	</Section>
	<BookInterview />
</Layout>
